import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CardActionArea, CardMedia, Fade, styled, useMediaQuery } from '@mui/material'
import { decodeTrademarkEntity } from '@helpers/string-helper'

const StyledCardActionArea = styled(CardActionArea)`
  aspect-ratio: 3/2;

  img {
    aspect-ratio: 3/2;
    object-fit: contain !important;
    background-color: ${p => p.theme.palette.secondary.light};
    color: transparent;
    img:-moz-loading {
      visibility: hidden;
    }
  }

  .AddToCartButtonIcon {
    position: absolute;
    right: 8px;
    bottom: 8px;
    z-index: 1;
  }
`

export default function ProductTileImage(props) {
  const { onClick, alternateImage, primaryImage, title } = props
  const [isHoveringImage, setIsHoveringImage] = useState(false)

  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))
  const alternateImageUrl = alternateImage ? `${alternateImage}&h=385` : null
  const primaryImageUrl = primaryImage ? `${primaryImage}&h=385` : null

  useEffect(() => {
    if (alternateImageUrl) document.createElement('img').src = alternateImageUrl
  }, [alternateImageUrl])

  const showHoverImage = alternateImageUrl && !isMobile

  return (
    <StyledCardActionArea
      component="div"
      tabIndex={0}
      disableRipple
      onClick={onClick}
      onMouseOver={() => {
        if (showHoverImage) {
          setIsHoveringImage(true)
        }
      }}
      onMouseOut={() => {
        if (showHoverImage) {
          setIsHoveringImage(false)
        }
      }}
      aria-hidden="true"
    >
      {!isHoveringImage && (
        <CardMedia
          width="535px"
          component="img"
          aria-hidden="true"
          role="presentation"
          alt={title}
          title={decodeTrademarkEntity(title)}
          image={primaryImageUrl}
          sx={{
            display: !isHoveringImage,
            padding: primaryImageUrl && primaryImageUrl.search(/image-room|image-3-2/) > -1 ? '0' : '29px',
          }}
        />
      )}
      {isHoveringImage && alternateImageUrl && (
        <Fade in={isHoveringImage}>
          <CardMedia
            width="535px"
            component="img"
            aria-hidden="true"
            role="presentation"
            alt={title}
            title={decodeTrademarkEntity(title)}
            image={alternateImageUrl}
            sx={{
              padding: alternateImageUrl && alternateImageUrl.search(/image-room|image-3-2/) > -1 ? '0' : '29px',
            }}
            className="alternate-image"
          />
        </Fade>
      )}
    </StyledCardActionArea>
  )
}

ProductTileImage.propTypes = {
  primaryImage: PropTypes.string.isRequired,
  alternateImage: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}
